<template>
  <div id="dashboard-report-frame" style="height: 100vh">
    <iframe v-if="embeddedURL" title="Sample Report Demo" width="100%" height="100%" :src="embeddedURL" frameborder="0"
      allowFullScreen="true"></iframe>
    <!-- <statistics-card></statistics-card>
    <div class="vx-row">
      <project-status-chart></project-status-chart>
      <vessel-type-chart
        v-if="$store.state.userInfo.type !== 'CN'"
      ></vessel-type-chart>
    </div>
    <project-listing></project-listing> -->
  </div>
</template>

<script>
import StatisticsCard from "@/layouts/components/dashboard/statisticsCard.vue";
import ProjectStatusChart from "@/layouts/components/dashboard/projectStatusChart.vue";
import ProjectListing from "@/layouts/components/dashboard/projectListing.vue";
import VesselTypeChart from "@/layouts/components/dashboard/vesselTypeChart.vue";

export default {
  components: {
    StatisticsCard,
    ProjectStatusChart,
    ProjectListing,
    VesselTypeChart,
  },
  data() {
    return {
      embeddedURL: null,
    };
  },
  methods: {
    async getPowerBi() {
      const res = await this.getHTTPGetResponse("dashboard/power-bi");
      if (res.status == 200) {
        const powerBi = res.data.powerBi;
        if (powerBi.length) {
          this.embeddedURL = powerBi[0].url;
        }
      }
    },
  },
  created() {
    this.getPowerBi();
  },
};
</script>
